import styled from 'styled-components';

export default styled.div`
  margin-top: 50px;
  text-align: center;
`;
